import React, { Component } from 'react';

import { t } from 'l10n';
import paths from 'paths';

import AutoSuggest from 'components/autosuggest/AutoSuggest';
import { NavLink, Redirect } from 'components/ReactRouterDomLocalized';
import AutoSuggestDataProvider from 'containers/member/AutosuggestDataProvider';

import '../../sass/headers/headerMemberMessage.scss';

class MessageHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            pending: false,
            newMessage: false,
        }
    }

    onNewMessage() {
        if (this.props.onNewMessage && typeof this.props.onNewMessage == 'function') {
            this.props.onNewMessage(this.state.user);
        } else {
            this.setState({newMessage: true});
        }
    }

    render() {
        const { user, pending, newMessage } = this.state;
        const { title, showForm, newCount, trashCount, messagesCount } = this.props;

        const dataProvider = new AutoSuggestDataProvider();

        if(newMessage) return <Redirect to={paths.memberMessageDialog.path + user.id} />;

        return (
            <header className="header-member-message">
                <div className="content">
                    <h1>{title}</h1>
                    <div className="text-member-message">
                        <div className="info">
                            <NavLink to={paths.memberMessageListMessages.path} className="message" activeClassName="active">
                                {t('Messages')} <span>({messagesCount})</span>
                                {newCount ? <div className="number">{newCount}</div> : null}
                            </NavLink>
                            <NavLink to={paths.memberMessageListTrash.path} className="trach" activeClassName="active">
                                {t('Trash')} <span>({trashCount})</span>
                            </NavLink>
                        </div>
                        {showForm ? (
                            <div className="search">
                                <AutoSuggest
                                    placeholder={t('Enter nick of the user')}
                                    dataProvider={dataProvider}
                                    onSelect={(item) => this.setState({user: item})}
                                    value={user ? user.nick : ''}
                                />
                                <button
                                    type="submit"
                                    className={'ui-button primary btn-submit btnCreateDialog' + (pending ? 'loading' : '')}
                                    disabled={user && !pending ? null : 'disabled'}
                                    onClick={() => this.onNewMessage()}
                                >
                                    {pending ? t('Please wait...') : t('New message')}
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </header>
        )
    }
}


export default MessageHeader;


// WEBPACK FOOTER //
// ./src/components/message/MessageHeader.js